import React, { useEffect, useRef, useState } from 'react';
import Popup from 'reactjs-popup';
import axios from 'axios';
import NoContentFound from '../not-found/notFound';
import { ShimmerCategoryItem } from 'react-shimmer-effects';
import SearchForm from '../search/searchForm';
import ShimmerImage from './shimmerImage/shimmerImage';
import { InitialAvatar } from '../utils/defaultAvatar';

const ItemsSelectorPopup = ({ openModal, setOpen, type, title, onItemSelect }) => {
  const closeModal = () => {
    setOpen(false);
    setHasLoaded(false);
  };
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const prevSearchTermRef = useRef();
  const [error, setError] = useState('');
  const [url, setUrl] = useState('');
  const [items, setItems] = useState({
    data: [],
    pagination: {}
  });

  const urlMapping = {
    cards: 'card/search/',
    card_connects: 'card/connects/search/',
    prospectors: 'prospector/search/',
    business: 'business/category/search',
    files: 'files/search/',
  };

  useEffect(() => {
    const newUrl = urlMapping[type] || '';
    setUrl(newUrl);
    //set item data
    if (openModal && !hasLoaded) {
      setIsLoading(true);
      fetchItems();
    }

  }, [openModal, type]);

  useEffect(() => {
    // set search data
    if (prevSearchTermRef.current !== searchTerm) {
      searchItems();
    }
    prevSearchTermRef.current = searchTerm;


  }, [searchTerm]);

  // Reusable fetch function
  const fetchData = async (postData, url, onSuccess, onError) => {
    try {
      const response = await axios.get(url, { params: postData });
      onSuccess(response.data);
    } catch (err) {
      console.error(err);
      onError('Failed to fetch items.');
    }
  };

  // Fetch initial 
  const fetchItems = () => {
    let postData = { page: 1, keyword: '', limit: 5 };

    fetchData(
      postData,
      url,
      (data) => {
        setItems(data);
        setHasLoaded(true);
      },
      setError
    ).finally(() => setIsLoading(false));
  };

  // Search for items
  const searchItems = () => {
    if (!hasLoaded) return;
    setLoading(true);

    let postData = { page: 1, keyword: searchTerm, limit: 5 };

    fetchData(
      postData,
      url,
      setItems,
      setError
    ).finally(() => setLoading(false));
  };

  // Load more items
  const loadMore = () => {
    setIsLoading(true);
    const nextPage = items.pagination.page + 1;

    if (nextPage <= items.pagination.page_last) {
      setPageCount(nextPage);

      let postData = { page: nextPage, keyword: searchTerm, limit: 5 };

      fetchData(
        postData,
        url,
        (data) => {
          if (Array.isArray(data.data)) {
            setItems((prev) => ({
              data: [...prev.data, ...data.data],
              pagination: data.pagination,
            }));
          }
        },
        setError
      ).finally(() => setIsLoading(false));
    }
  };

  return (
    <div>
      <Popup open={openModal} closeOnDocumentClick onClose={closeModal} lockScroll={true}>
        <div className="modal">
          <div className="modal-header">
            <h3>{title ? title : "Select Item"}</h3>
            <SearchForm
              placeholder='Search card...'
              loading={loading}
              onChange={async (val) => {
                setSearchTerm(val);
              }}
            />
          </div>
          <div className="modal-content table-modal-list">
            <div className="list-table connection-pp-list list-overflow">
              <table>
                <tbody>
                  {Array.isArray(items.data) && items.data.length > 0 && items.data.map((item, index) => (
                    <tr key={index} onClick={() => onItemSelect(item)}>
                      <td>
                        <div className="list-profile">
                          {item.iconUrl ? (
                            <ShimmerImage
                              src={item.iconUrl}
                              alt={item.title}
                              width={50}
                            />
                          ) : (
                            <InitialAvatar
                              title={`${item.title}`}
                              size={50}
                            />
                          )}
                          <div className="lst-profile-info">
                            <span>{item.title ? item.title : "Untitled"}</span>
                            <p>{item.subtitle}</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {!isLoading && !items.data &&
                <NoContentFound title="No item found!" />
              }
              {isLoading &&
                <>
                  <ShimmerCategoryItem
                    hasImage
                    imageType="circular"
                    imageWidth={50}
                    imageHeight={50}
                    text
                  />
                  <ShimmerCategoryItem
                    hasImage
                    imageType="circular"
                    imageWidth={50}
                    imageHeight={50}
                    text
                  />
                </>
              }
              {!isLoading && items.data && items.pagination.page_last > items.pagination.page && (
                <div className="load-more-container">
                  <button
                    className="load-more-btn"
                    onClick={loadMore}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Loading...' : 'Load More'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
};
export default ItemsSelectorPopup;